import VpAccessibilityIcon from './Accessibility.svelte';
import VpAddCircleIcon from './AddCircle.svelte';
import VpAddIcon from './Add.svelte';
import VpAlignBottomIcon from './AlignBottom.svelte';
import VpAlignTopIcon from './AlignTop.svelte';
import VpAlignVerticallyIcon from './AlignVertically.svelte';
import VpAlignementCenterIcon from './AlignementCenter.svelte';
import VpAlignementLeftIcon from './AlignementLeft.svelte';
import VpAlignementRightIcon from './AlignementRight.svelte';
import VpArrowBackwardCircleIcon from './ArrowBackwardCircle.svelte';
import VpArrowBackwardIcon from './ArrowBackward.svelte';
import VpArrowDownCircleIcon from './ArrowDownCircle.svelte';
import VpArrowDownIcon from './ArrowDown.svelte';
import VpArrowExpandHorIcon from './ArrowExpandHor.svelte';
import VpArrowForwardCircleIcon from './ArrowForwardCircle.svelte';
import VpArrowForwardIcon from './ArrowForward.svelte';
import VpArrowLeftCircleIcon from './ArrowLeftCircle.svelte';
import VpArrowLeftDownIcon from './ArrowLeftDown.svelte';
import VpArrowLeftRightIcon from './ArrowLeftRight.svelte';
import VpArrowLeftUpIcon from './ArrowLeftUp.svelte';
import VpArrowLeftIcon from './ArrowLeft.svelte';
import VpArrowRightCircleIcon from './ArrowRightCircle.svelte';
import VpArrowRightDownIcon from './ArrowRightDown.svelte';
import VpArrowRightUpIcon from './ArrowRightUp.svelte';
import VpArrowRightIcon from './ArrowRight.svelte';
import VpArrowUpCircleIcon from './ArrowUpCircle.svelte';
import VpArrowUpDownIcon from './ArrowUpDown.svelte';
import VpArrowUpIcon from './ArrowUp.svelte';
import VpArrowUturnBackwardIcon from './ArrowUturnBackward.svelte';
import VpArrowUturnForwardIcon from './ArrowUturnForward.svelte';
import VpArrowUturnLeftIcon from './ArrowUturnLeft.svelte';
import VpArrowUturnRightIcon from './ArrowUturnRight.svelte';
import VpAttachement1Icon from './Attachement1.svelte';
import VpAttachementIcon from './Attachement.svelte';
import VpAwardIcon from './Award.svelte';
import VpBalanceIcon from './Balance.svelte';
import VpBankCardIcon from './BankCard.svelte';
import VpBarChartIcon from './BarChart.svelte';
import VpBarcodeScanIcon from './BarcodeScan.svelte';
import VpBezierCurveIcon from './BezierCurve.svelte';
import VpBillIcon from './Bill.svelte';
import VpBodyScanIcon from './BodyScan.svelte';
import VpBoldIcon from './Bold.svelte';
import VpCalendarCheckIcon from './CalendarCheck.svelte';
import VpCalendarDateIcon from './CalendarDate.svelte';
import VpCalendarIcon from './Calendar.svelte';
import VpCameraIcon from './Camera.svelte';
import VpCarIcon from './Car.svelte';
import VpCheckCircleIcon from './CheckCircle.svelte';
import VpCheckIcon from './Check.svelte';
import VpCheckboxMultipleIcon from './CheckboxMultiple.svelte';
import VpChevronBackwardIcon from './ChevronBackward.svelte';
import VpChevronDownIcon from './ChevronDown.svelte';
import VpChevronForwardIcon from './ChevronForward.svelte';
import VpChevronLeftIcon from './ChevronLeft.svelte';
import VpChevronRightIcon from './ChevronRight.svelte';
import VpChevronUpIcon from './ChevronUp.svelte';
import VpCircularityBuyBackIcon from './CircularityBuyBack.svelte';
import VpCircularityMaintainRepairIcon from './CircularityMaintainRepair.svelte';
import VpCircularitySecondLifeIcon from './CircularitySecondLife.svelte';
import VpCircularityShopRentalIcon from './CircularityShopRental.svelte';
import VpClickCollectIcon from './ClickCollect.svelte';
import VpCloseCircleIcon from './CloseCircle.svelte';
import VpCloseIcon from './Close.svelte';
import VpCloudWindyIcon from './CloudWindy.svelte';
import VpCloudIcon from './Cloud.svelte';
import VpCodeBracketsIcon from './CodeBrackets.svelte';
import VpCounterHighIcon from './CounterHigh.svelte';
import VpCounterLowIcon from './CounterLow.svelte';
import VpCreditCardIcon from './CreditCard.svelte';
import VpCustomerServiceIcon from './CustomerService.svelte';
import VpCustomizeIcon from './Customize.svelte';
import VpDatabaseIcon from './Database.svelte';
import VpDeleteBinIcon from './DeleteBin.svelte';
import VpDevicesIcon from './Devices.svelte';
import VpDirectionIcon from './Direction.svelte';
import VpDownloadIcon from './Download.svelte';
import VpDrizzleIcon from './Drizzle.svelte';
import VpEarthIcon from './Earth.svelte';
import VpEditIcon from './Edit.svelte';
import VpEmotionHappyIcon from './EmotionHappy.svelte';
import VpEmotionLaughIcon from './EmotionLaugh.svelte';
import VpEmotionNeutralIcon from './EmotionNeutral.svelte';
import VpEmotionSadIcon from './EmotionSad.svelte';
import VpEmotionUnhappyIcon from './EmotionUnhappy.svelte';
import VpEqualizerIcon from './Equalizer.svelte';
import VpErrorIcon from './Error.svelte';
import VpExchangeIcon from './Exchange.svelte';
import VpExitFullscreenIcon from './ExitFullscreen.svelte';
import VpExpandIcon from './Expand.svelte';
import VpExperimentIcon from './Experiment.svelte';
import VpExternalLinkIcon from './ExternalLink.svelte';
import VpEyeClosedIcon from './EyeClosed.svelte';
import VpEyeOffIcon from './EyeOff.svelte';
import VpEyeIcon from './Eye.svelte';
import VpFastDeliveryIcon from './FastDelivery.svelte';
import VpFeedbackIcon from './Feedback.svelte';
import VpFileIcon from './File.svelte';
import VpFilmIcon from './Film.svelte';
import VpFilterOffIcon from './FilterOff.svelte';
import VpFilterIcon from './Filter.svelte';
import VpFireIcon from './Fire.svelte';
import VpFlashlightIcon from './Flashlight.svelte';
import VpFocusIcon from './Focus.svelte';
import VpFoggyIcon from './Foggy.svelte';
import VpFontSizeIcon from './FontSize.svelte';
import VpFootballIcon from './Football.svelte';
import VpForbidIcon from './Forbid.svelte';
import VpFullscreenIcon from './Fullscreen.svelte';
import VpFunctionRowsIcon from './FunctionRows.svelte';
import VpFunctionTilesIcon from './FunctionTiles.svelte';
import VpFundingIcon from './Funding.svelte';
import VpGiftIcon from './Gift.svelte';
import VpGiftcardsIcon from './Giftcards.svelte';
import VpGridIcon from './Grid.svelte';
import VpGroupIcon from './Group.svelte';
import VpHailIcon from './Hail.svelte';
import VpHearingImpairmentIcon from './HearingImpairment.svelte';
import VpHeartFilledIcon from './HeartFilled.svelte';
import VpHeartPulseIcon from './HeartPulse.svelte';
import VpHeartIcon from './Heart.svelte';
import VpHistoryIcon from './History.svelte';
import VpHomeIcon from './Home.svelte';
import VpHourglassIcon from './Hourglass.svelte';
import VpImageIcon from './Image.svelte';
import VpInformationIcon from './Information.svelte';
import VpInsurranceIcon from './Insurrance.svelte';
import VpItalicIcon from './Italic.svelte';
import VpKeyboardIcon from './Keyboard.svelte';
import VpLeafIcon from './Leaf.svelte';
import VpLightbulbIcon from './Lightbulb.svelte';
import VpLightningIcon from './Lightning.svelte';
import VpLineChartIcon from './LineChart.svelte';
import VpLinkIcon from './Link.svelte';
import VpListCheckIcon from './ListCheck.svelte';
import VpListSettingsIcon from './ListSettings.svelte';
import VpLockIcon from './Lock.svelte';
import VpLogoutIcon from './Logout.svelte';
import VpLoyaltyCardIcon from './LoyaltyCard.svelte';
import VpMacIcon from './Mac.svelte';
import VpMacbookIcon from './Macbook.svelte';
import VpMailSendIcon from './MailSend.svelte';
import VpMailIcon from './Mail.svelte';
import VpMaintainRepairIcon from './MaintainRepair.svelte';
import VpMapPinIcon from './MapPin.svelte';
import VpMastercardIcon from './Mastercard.svelte';
import VpMaximizeIcon from './Maximize.svelte';
import VpMenuIcon from './Menu.svelte';
import VpMessageIcon from './Message.svelte';
import VpMicOffIcon from './MicOff.svelte';
import VpMicIcon from './Mic.svelte';
import VpMistIcon from './Mist.svelte';
import VpMoneyCnyBoxIcon from './MoneyCnyBox.svelte';
import VpMoneyDollarBoxIcon from './MoneyDollarBox.svelte';
import VpMoneyEuroBoxIcon from './MoneyEuroBox.svelte';
import VpMoneyPoundBoxIcon from './MoneyPoundBox.svelte';
import VpMoonCloudyIcon from './MoonCloudy.svelte';
import VpMoonIcon from './Moon.svelte';
import VpMore2Icon from './More2.svelte';
import VpMoreIcon from './More.svelte';
import VpMusic1Icon from './Music1.svelte';
import VpMusic2Icon from './Music2.svelte';
import VpNavigationIcon from './Navigation.svelte';
import VpNotificationIcon from './Notification.svelte';
import VpOrderTrackingIcon from './OrderTracking.svelte';
import VpParcelLockersIcon from './ParcelLockers.svelte';
import VpPauseCircleIcon from './PauseCircle.svelte';
import VpPauseFilledIcon from './PauseFilled.svelte';
import VpPauseIcon from './Pause.svelte';
import VpPhoneIcon from './Phone.svelte';
import VpPickUpPackstationIcon from './PickUpPackstation.svelte';
import VpPickUpStoreIcon from './PickUpStore.svelte';
import VpPictureInPictureIcon from './PictureInPicture.svelte';
import VpPieChartIcon from './PieChart.svelte';
import VpPlayCircleIcon from './PlayCircle.svelte';
import VpPlayFilledIcon from './PlayFilled.svelte';
import VpPlayIcon from './Play.svelte';
import VpPowerIcon from './Power.svelte';
import VpPriceTagIcon from './PriceTag.svelte';
import VpPrinterIcon from './Printer.svelte';
import VpQrCodeIcon from './QrCode.svelte';
import VpQrScanIcon from './QrScan.svelte';
import VpQuestionIcon from './Question.svelte';
import VpRainyIcon from './Rainy.svelte';
import VpRecycleIcon from './Recycle.svelte';
import VpRefreshIcon from './Refresh.svelte';
import VpRefundIcon from './Refund.svelte';
import VpRentIcon from './Rent.svelte';
import VpRepairIcon from './Repair.svelte';
import VpRepeatIcon from './Repeat.svelte';
import VpReturnIcon from './Return.svelte';
import VpRidingIcon from './Riding.svelte';
import VpRocketIcon from './Rocket.svelte';
import VpRssIcon from './Rss.svelte';
import VpRulerIcon from './Ruler.svelte';
import VpRunIcon from './Run.svelte';
import VpSearchIcon from './Search.svelte';
import VpSecondUseIcon from './SecondUse.svelte';
import VpSecurePaymentIcon from './SecurePayment.svelte';
import VpSeed1Icon from './Seed1.svelte';
import VpSeed2Icon from './Seed2.svelte';
import VpSeed3Icon from './Seed3.svelte';
import VpSendPlaneTopIcon from './SendPlaneTop.svelte';
import VpSendPlaneIcon from './SendPlane.svelte';
import VpSettingsIcon from './Settings.svelte';
import VpShareAndroidIcon from './ShareAndroid.svelte';
import VpShareAppleIcon from './ShareApple.svelte';
import VpShieldCheckIcon from './ShieldCheck.svelte';
import VpShoppingAddToBagIcon from './ShoppingAddToBag.svelte';
import VpShoppingBagIcon from './ShoppingBag.svelte';
import VpShoppingCartIcon from './ShoppingCart.svelte';
import VpShowerIcon from './Shower.svelte';
import VpSmartphoneIcon from './Smartphone.svelte';
import VpSnowyIcon from './Snowy.svelte';
import VpSparklesIcon from './Sparkles.svelte';
import VpStarFilledIcon from './StarFilled.svelte';
import VpStarHalfFilledIcon from './StarHalfFilled.svelte';
import VpStarIcon from './Star.svelte';
import VpStopCircleIcon from './StopCircle.svelte';
import VpStopFilledIcon from './StopFilled.svelte';
import VpStopIcon from './Stop.svelte';
import VpStoreIcon from './Store.svelte';
import VpSubtractIcon from './Subtract.svelte';
import VpSuitcaseStickersIcon from './SuitcaseStickers.svelte';
import VpSuitcaseWorkIcon from './SuitcaseWork.svelte';
import VpSunCloudyIcon from './SunCloudy.svelte';
import VpSunIcon from './Sun.svelte';
import VpTShirtNumberIcon from './TShirtNumber.svelte';
import VpTShirtIcon from './TShirt.svelte';
import VpTabletIcon from './Tablet.svelte';
import VpTacticsIcon from './Tactics.svelte';
import VpTaskIcon from './Task.svelte';
import VpTempColdIcon from './TempCold.svelte';
import VpTempHotIcon from './TempHot.svelte';
import VpTextCurvedIcon from './TextCurved.svelte';
import VpTextIcon from './Text.svelte';
import VpThumbDownIcon from './ThumbDown.svelte';
import VpThumbUpIcon from './ThumbUp.svelte';
import VpThunderstormsIcon from './Thunderstorms.svelte';
import VpTimeIcon from './Time.svelte';
import VpTimerIcon from './Timer.svelte';
import VpToolsIcon from './Tools.svelte';
import VpTrainIcon from './Train.svelte';
import VpTrophyIcon from './Trophy.svelte';
import VpTruckIcon from './Truck.svelte';
import VpUnlinkIcon from './Unlink.svelte';
import VpUploadIcon from './Upload.svelte';
import VpUserIcon from './User.svelte';
import VpVectorIcon from './Vector.svelte';
import VpVideoIcon from './Video.svelte';
import VpVolumeAlertIcon from './VolumeAlert.svelte';
import VpVolumeDownIcon from './VolumeDown.svelte';
import VpVolumeMuteIcon from './VolumeMute.svelte';
import VpVolumeUpIcon from './VolumeUp.svelte';
import VpWalkIcon from './Walk.svelte';
import VpWalletIcon from './Wallet.svelte';
import VpWarningErrorIcon from './WarningError.svelte';
import VpWifiOffIcon from './WifiOff.svelte';
import VpWifiOnIcon from './WifiOn.svelte';
import VpWindyIcon from './Windy.svelte';
import VpZoomInIcon from './ZoomIn.svelte';
import VpZoomOutIcon from './ZoomOut.svelte';
const getIconsMap = () => ({
    "accessibility": VpAccessibilityIcon,
    "add-circle": VpAddCircleIcon,
    "add": VpAddIcon,
    "align-bottom": VpAlignBottomIcon,
    "align-top": VpAlignTopIcon,
    "align-vertically": VpAlignVerticallyIcon,
    "alignement-center": VpAlignementCenterIcon,
    "alignement-left": VpAlignementLeftIcon,
    "alignement-right": VpAlignementRightIcon,
    "arrow-backward-circle": VpArrowBackwardCircleIcon,
    "arrow-backward": VpArrowBackwardIcon,
    "arrow-down-circle": VpArrowDownCircleIcon,
    "arrow-down": VpArrowDownIcon,
    "arrow-expand-hor": VpArrowExpandHorIcon,
    "arrow-forward-circle": VpArrowForwardCircleIcon,
    "arrow-forward": VpArrowForwardIcon,
    "arrow-left-circle": VpArrowLeftCircleIcon,
    "arrow-left-down": VpArrowLeftDownIcon,
    "arrow-left-right": VpArrowLeftRightIcon,
    "arrow-left-up": VpArrowLeftUpIcon,
    "arrow-left": VpArrowLeftIcon,
    "arrow-right-circle": VpArrowRightCircleIcon,
    "arrow-right-down": VpArrowRightDownIcon,
    "arrow-right-up": VpArrowRightUpIcon,
    "arrow-right": VpArrowRightIcon,
    "arrow-up-circle": VpArrowUpCircleIcon,
    "arrow-up-down": VpArrowUpDownIcon,
    "arrow-up": VpArrowUpIcon,
    "arrow-uturn-backward": VpArrowUturnBackwardIcon,
    "arrow-uturn-forward": VpArrowUturnForwardIcon,
    "arrow-uturn-left": VpArrowUturnLeftIcon,
    "arrow-uturn-right": VpArrowUturnRightIcon,
    "attachement-1": VpAttachement1Icon,
    "attachement": VpAttachementIcon,
    "award": VpAwardIcon,
    "balance": VpBalanceIcon,
    "bank-card": VpBankCardIcon,
    "bar-chart": VpBarChartIcon,
    "barcode-scan": VpBarcodeScanIcon,
    "bezier-curve": VpBezierCurveIcon,
    "bill": VpBillIcon,
    "body-scan": VpBodyScanIcon,
    "bold": VpBoldIcon,
    "calendar-check": VpCalendarCheckIcon,
    "calendar-date": VpCalendarDateIcon,
    "calendar": VpCalendarIcon,
    "camera": VpCameraIcon,
    "car": VpCarIcon,
    "check-circle": VpCheckCircleIcon,
    "check": VpCheckIcon,
    "checkbox-multiple": VpCheckboxMultipleIcon,
    "chevron-backward": VpChevronBackwardIcon,
    "chevron-down": VpChevronDownIcon,
    "chevron-forward": VpChevronForwardIcon,
    "chevron-left": VpChevronLeftIcon,
    "chevron-right": VpChevronRightIcon,
    "chevron-up": VpChevronUpIcon,
    "circularity-buy-back": VpCircularityBuyBackIcon,
    "circularity-maintain-repair": VpCircularityMaintainRepairIcon,
    "circularity-second-life": VpCircularitySecondLifeIcon,
    "circularity-shop-rental": VpCircularityShopRentalIcon,
    "click-collect": VpClickCollectIcon,
    "close-circle": VpCloseCircleIcon,
    "close": VpCloseIcon,
    "cloud-windy": VpCloudWindyIcon,
    "cloud": VpCloudIcon,
    "code-brackets": VpCodeBracketsIcon,
    "counter-high": VpCounterHighIcon,
    "counter-low": VpCounterLowIcon,
    "credit-card": VpCreditCardIcon,
    "customer-service": VpCustomerServiceIcon,
    "customize": VpCustomizeIcon,
    "database": VpDatabaseIcon,
    "delete-bin": VpDeleteBinIcon,
    "devices": VpDevicesIcon,
    "direction": VpDirectionIcon,
    "download": VpDownloadIcon,
    "drizzle": VpDrizzleIcon,
    "earth": VpEarthIcon,
    "edit": VpEditIcon,
    "emotion-happy": VpEmotionHappyIcon,
    "emotion-laugh": VpEmotionLaughIcon,
    "emotion-neutral": VpEmotionNeutralIcon,
    "emotion-sad": VpEmotionSadIcon,
    "emotion-unhappy": VpEmotionUnhappyIcon,
    "equalizer": VpEqualizerIcon,
    "error": VpErrorIcon,
    "exchange": VpExchangeIcon,
    "exit-fullscreen": VpExitFullscreenIcon,
    "expand": VpExpandIcon,
    "experiment": VpExperimentIcon,
    "external-link": VpExternalLinkIcon,
    "eye-closed": VpEyeClosedIcon,
    "eye-off": VpEyeOffIcon,
    "eye": VpEyeIcon,
    "fast-delivery": VpFastDeliveryIcon,
    "feedback": VpFeedbackIcon,
    "file": VpFileIcon,
    "film": VpFilmIcon,
    "filter-off": VpFilterOffIcon,
    "filter": VpFilterIcon,
    "fire": VpFireIcon,
    "flashlight": VpFlashlightIcon,
    "focus": VpFocusIcon,
    "foggy": VpFoggyIcon,
    "font-size": VpFontSizeIcon,
    "football": VpFootballIcon,
    "forbid": VpForbidIcon,
    "fullscreen": VpFullscreenIcon,
    "function-rows": VpFunctionRowsIcon,
    "function-tiles": VpFunctionTilesIcon,
    "funding": VpFundingIcon,
    "gift": VpGiftIcon,
    "giftcards": VpGiftcardsIcon,
    "grid": VpGridIcon,
    "group": VpGroupIcon,
    "hail": VpHailIcon,
    "hearing-impairment": VpHearingImpairmentIcon,
    "heart-filled": VpHeartFilledIcon,
    "heart-pulse": VpHeartPulseIcon,
    "heart": VpHeartIcon,
    "history": VpHistoryIcon,
    "home": VpHomeIcon,
    "hourglass": VpHourglassIcon,
    "image": VpImageIcon,
    "information": VpInformationIcon,
    "insurrance": VpInsurranceIcon,
    "italic": VpItalicIcon,
    "keyboard": VpKeyboardIcon,
    "leaf": VpLeafIcon,
    "lightbulb": VpLightbulbIcon,
    "lightning": VpLightningIcon,
    "line-chart": VpLineChartIcon,
    "link": VpLinkIcon,
    "list-check": VpListCheckIcon,
    "list-settings": VpListSettingsIcon,
    "lock": VpLockIcon,
    "logout": VpLogoutIcon,
    "loyalty-card": VpLoyaltyCardIcon,
    "mac": VpMacIcon,
    "macbook": VpMacbookIcon,
    "mail-send": VpMailSendIcon,
    "mail": VpMailIcon,
    "maintain-repair": VpMaintainRepairIcon,
    "map-pin": VpMapPinIcon,
    "mastercard": VpMastercardIcon,
    "maximize": VpMaximizeIcon,
    "menu": VpMenuIcon,
    "message": VpMessageIcon,
    "mic-off": VpMicOffIcon,
    "mic": VpMicIcon,
    "mist": VpMistIcon,
    "money-cny-box": VpMoneyCnyBoxIcon,
    "money-dollar-box": VpMoneyDollarBoxIcon,
    "money-euro-box": VpMoneyEuroBoxIcon,
    "money-pound-box": VpMoneyPoundBoxIcon,
    "moon-cloudy": VpMoonCloudyIcon,
    "moon": VpMoonIcon,
    "more-2": VpMore2Icon,
    "more": VpMoreIcon,
    "music-1": VpMusic1Icon,
    "music-2": VpMusic2Icon,
    "navigation": VpNavigationIcon,
    "notification": VpNotificationIcon,
    "order-tracking": VpOrderTrackingIcon,
    "parcel-lockers": VpParcelLockersIcon,
    "pause-circle": VpPauseCircleIcon,
    "pause-filled": VpPauseFilledIcon,
    "pause": VpPauseIcon,
    "phone": VpPhoneIcon,
    "pick-up-packstation": VpPickUpPackstationIcon,
    "pick-up-store": VpPickUpStoreIcon,
    "picture-in-picture": VpPictureInPictureIcon,
    "pie-chart": VpPieChartIcon,
    "play-circle": VpPlayCircleIcon,
    "play-filled": VpPlayFilledIcon,
    "play": VpPlayIcon,
    "power": VpPowerIcon,
    "price-tag": VpPriceTagIcon,
    "printer": VpPrinterIcon,
    "qr-code": VpQrCodeIcon,
    "qr-scan": VpQrScanIcon,
    "question": VpQuestionIcon,
    "rainy": VpRainyIcon,
    "recycle": VpRecycleIcon,
    "refresh": VpRefreshIcon,
    "refund": VpRefundIcon,
    "rent": VpRentIcon,
    "repair": VpRepairIcon,
    "repeat": VpRepeatIcon,
    "return": VpReturnIcon,
    "riding": VpRidingIcon,
    "rocket": VpRocketIcon,
    "rss": VpRssIcon,
    "ruler": VpRulerIcon,
    "run": VpRunIcon,
    "search": VpSearchIcon,
    "second-use": VpSecondUseIcon,
    "secure-payment": VpSecurePaymentIcon,
    "seed-1": VpSeed1Icon,
    "seed-2": VpSeed2Icon,
    "seed-3": VpSeed3Icon,
    "send-plane-top": VpSendPlaneTopIcon,
    "send-plane": VpSendPlaneIcon,
    "settings": VpSettingsIcon,
    "share-android": VpShareAndroidIcon,
    "share-apple": VpShareAppleIcon,
    "shield-check": VpShieldCheckIcon,
    "shopping-add-to-bag": VpShoppingAddToBagIcon,
    "shopping-bag": VpShoppingBagIcon,
    "shopping-cart": VpShoppingCartIcon,
    "shower": VpShowerIcon,
    "smartphone": VpSmartphoneIcon,
    "snowy": VpSnowyIcon,
    "sparkles": VpSparklesIcon,
    "star-filled": VpStarFilledIcon,
    "star-half-filled": VpStarHalfFilledIcon,
    "star": VpStarIcon,
    "stop-circle": VpStopCircleIcon,
    "stop-filled": VpStopFilledIcon,
    "stop": VpStopIcon,
    "store": VpStoreIcon,
    "subtract": VpSubtractIcon,
    "suitcase-stickers": VpSuitcaseStickersIcon,
    "suitcase-work": VpSuitcaseWorkIcon,
    "sun-cloudy": VpSunCloudyIcon,
    "sun": VpSunIcon,
    "t-shirt-number": VpTShirtNumberIcon,
    "t-shirt": VpTShirtIcon,
    "tablet": VpTabletIcon,
    "tactics": VpTacticsIcon,
    "task": VpTaskIcon,
    "temp-cold": VpTempColdIcon,
    "temp-hot": VpTempHotIcon,
    "text-curved": VpTextCurvedIcon,
    "text": VpTextIcon,
    "thumb-down": VpThumbDownIcon,
    "thumb-up": VpThumbUpIcon,
    "thunderstorms": VpThunderstormsIcon,
    "time": VpTimeIcon,
    "timer": VpTimerIcon,
    "tools": VpToolsIcon,
    "train": VpTrainIcon,
    "trophy": VpTrophyIcon,
    "truck": VpTruckIcon,
    "unlink": VpUnlinkIcon,
    "upload": VpUploadIcon,
    "user": VpUserIcon,
    "vector": VpVectorIcon,
    "video": VpVideoIcon,
    "volume-alert": VpVolumeAlertIcon,
    "volume-down": VpVolumeDownIcon,
    "volume-mute": VpVolumeMuteIcon,
    "volume-up": VpVolumeUpIcon,
    "walk": VpWalkIcon,
    "wallet": VpWalletIcon,
    "warning-error": VpWarningErrorIcon,
    "wifi-off": VpWifiOffIcon,
    "wifi-on": VpWifiOnIcon,
    "windy": VpWindyIcon,
    "zoom-in": VpZoomInIcon,
    "zoom-out": VpZoomOutIcon,
});
export const ICON_STROKE_MAP = { "12": 1.25, "16": 1.5, "20": 1.5, "24": 1.5, "28": 1.5, "32": 2, "48": 2 };
export const ICON_SIZES = ["12", "16", "20", "24", "28", "32", "48"];
export const ICON_DEFAULT_SIZE = 24;
export { default as VpAccessibilityIcon } from './Accessibility.svelte';
export { default as VpAddCircleIcon } from './AddCircle.svelte';
export { default as VpAddIcon } from './Add.svelte';
export { default as VpAlignBottomIcon } from './AlignBottom.svelte';
export { default as VpAlignTopIcon } from './AlignTop.svelte';
export { default as VpAlignVerticallyIcon } from './AlignVertically.svelte';
export { default as VpAlignementCenterIcon } from './AlignementCenter.svelte';
export { default as VpAlignementLeftIcon } from './AlignementLeft.svelte';
export { default as VpAlignementRightIcon } from './AlignementRight.svelte';
export { default as VpArrowBackwardCircleIcon } from './ArrowBackwardCircle.svelte';
export { default as VpArrowBackwardIcon } from './ArrowBackward.svelte';
export { default as VpArrowDownCircleIcon } from './ArrowDownCircle.svelte';
export { default as VpArrowDownIcon } from './ArrowDown.svelte';
export { default as VpArrowExpandHorIcon } from './ArrowExpandHor.svelte';
export { default as VpArrowForwardCircleIcon } from './ArrowForwardCircle.svelte';
export { default as VpArrowForwardIcon } from './ArrowForward.svelte';
export { default as VpArrowLeftCircleIcon } from './ArrowLeftCircle.svelte';
export { default as VpArrowLeftDownIcon } from './ArrowLeftDown.svelte';
export { default as VpArrowLeftRightIcon } from './ArrowLeftRight.svelte';
export { default as VpArrowLeftUpIcon } from './ArrowLeftUp.svelte';
export { default as VpArrowLeftIcon } from './ArrowLeft.svelte';
export { default as VpArrowRightCircleIcon } from './ArrowRightCircle.svelte';
export { default as VpArrowRightDownIcon } from './ArrowRightDown.svelte';
export { default as VpArrowRightUpIcon } from './ArrowRightUp.svelte';
export { default as VpArrowRightIcon } from './ArrowRight.svelte';
export { default as VpArrowUpCircleIcon } from './ArrowUpCircle.svelte';
export { default as VpArrowUpDownIcon } from './ArrowUpDown.svelte';
export { default as VpArrowUpIcon } from './ArrowUp.svelte';
export { default as VpArrowUturnBackwardIcon } from './ArrowUturnBackward.svelte';
export { default as VpArrowUturnForwardIcon } from './ArrowUturnForward.svelte';
export { default as VpArrowUturnLeftIcon } from './ArrowUturnLeft.svelte';
export { default as VpArrowUturnRightIcon } from './ArrowUturnRight.svelte';
export { default as VpAttachement1Icon } from './Attachement1.svelte';
export { default as VpAttachementIcon } from './Attachement.svelte';
export { default as VpAwardIcon } from './Award.svelte';
export { default as VpBalanceIcon } from './Balance.svelte';
export { default as VpBankCardIcon } from './BankCard.svelte';
export { default as VpBarChartIcon } from './BarChart.svelte';
export { default as VpBarcodeScanIcon } from './BarcodeScan.svelte';
export { default as VpBezierCurveIcon } from './BezierCurve.svelte';
export { default as VpBillIcon } from './Bill.svelte';
export { default as VpBodyScanIcon } from './BodyScan.svelte';
export { default as VpBoldIcon } from './Bold.svelte';
export { default as VpCalendarCheckIcon } from './CalendarCheck.svelte';
export { default as VpCalendarDateIcon } from './CalendarDate.svelte';
export { default as VpCalendarIcon } from './Calendar.svelte';
export { default as VpCameraIcon } from './Camera.svelte';
export { default as VpCarIcon } from './Car.svelte';
export { default as VpCheckCircleIcon } from './CheckCircle.svelte';
export { default as VpCheckIcon } from './Check.svelte';
export { default as VpCheckboxMultipleIcon } from './CheckboxMultiple.svelte';
export { default as VpChevronBackwardIcon } from './ChevronBackward.svelte';
export { default as VpChevronDownIcon } from './ChevronDown.svelte';
export { default as VpChevronForwardIcon } from './ChevronForward.svelte';
export { default as VpChevronLeftIcon } from './ChevronLeft.svelte';
export { default as VpChevronRightIcon } from './ChevronRight.svelte';
export { default as VpChevronUpIcon } from './ChevronUp.svelte';
export { default as VpCircularityBuyBackIcon } from './CircularityBuyBack.svelte';
export { default as VpCircularityMaintainRepairIcon } from './CircularityMaintainRepair.svelte';
export { default as VpCircularitySecondLifeIcon } from './CircularitySecondLife.svelte';
export { default as VpCircularityShopRentalIcon } from './CircularityShopRental.svelte';
export { default as VpClickCollectIcon } from './ClickCollect.svelte';
export { default as VpCloseCircleIcon } from './CloseCircle.svelte';
export { default as VpCloseIcon } from './Close.svelte';
export { default as VpCloudWindyIcon } from './CloudWindy.svelte';
export { default as VpCloudIcon } from './Cloud.svelte';
export { default as VpCodeBracketsIcon } from './CodeBrackets.svelte';
export { default as VpCounterHighIcon } from './CounterHigh.svelte';
export { default as VpCounterLowIcon } from './CounterLow.svelte';
export { default as VpCreditCardIcon } from './CreditCard.svelte';
export { default as VpCustomerServiceIcon } from './CustomerService.svelte';
export { default as VpCustomizeIcon } from './Customize.svelte';
export { default as VpDatabaseIcon } from './Database.svelte';
export { default as VpDeleteBinIcon } from './DeleteBin.svelte';
export { default as VpDevicesIcon } from './Devices.svelte';
export { default as VpDirectionIcon } from './Direction.svelte';
export { default as VpDownloadIcon } from './Download.svelte';
export { default as VpDrizzleIcon } from './Drizzle.svelte';
export { default as VpEarthIcon } from './Earth.svelte';
export { default as VpEditIcon } from './Edit.svelte';
export { default as VpEmotionHappyIcon } from './EmotionHappy.svelte';
export { default as VpEmotionLaughIcon } from './EmotionLaugh.svelte';
export { default as VpEmotionNeutralIcon } from './EmotionNeutral.svelte';
export { default as VpEmotionSadIcon } from './EmotionSad.svelte';
export { default as VpEmotionUnhappyIcon } from './EmotionUnhappy.svelte';
export { default as VpEqualizerIcon } from './Equalizer.svelte';
export { default as VpErrorIcon } from './Error.svelte';
export { default as VpExchangeIcon } from './Exchange.svelte';
export { default as VpExitFullscreenIcon } from './ExitFullscreen.svelte';
export { default as VpExpandIcon } from './Expand.svelte';
export { default as VpExperimentIcon } from './Experiment.svelte';
export { default as VpExternalLinkIcon } from './ExternalLink.svelte';
export { default as VpEyeClosedIcon } from './EyeClosed.svelte';
export { default as VpEyeOffIcon } from './EyeOff.svelte';
export { default as VpEyeIcon } from './Eye.svelte';
export { default as VpFastDeliveryIcon } from './FastDelivery.svelte';
export { default as VpFeedbackIcon } from './Feedback.svelte';
export { default as VpFileIcon } from './File.svelte';
export { default as VpFilmIcon } from './Film.svelte';
export { default as VpFilterOffIcon } from './FilterOff.svelte';
export { default as VpFilterIcon } from './Filter.svelte';
export { default as VpFireIcon } from './Fire.svelte';
export { default as VpFlashlightIcon } from './Flashlight.svelte';
export { default as VpFocusIcon } from './Focus.svelte';
export { default as VpFoggyIcon } from './Foggy.svelte';
export { default as VpFontSizeIcon } from './FontSize.svelte';
export { default as VpFootballIcon } from './Football.svelte';
export { default as VpForbidIcon } from './Forbid.svelte';
export { default as VpFullscreenIcon } from './Fullscreen.svelte';
export { default as VpFunctionRowsIcon } from './FunctionRows.svelte';
export { default as VpFunctionTilesIcon } from './FunctionTiles.svelte';
export { default as VpFundingIcon } from './Funding.svelte';
export { default as VpGiftIcon } from './Gift.svelte';
export { default as VpGiftcardsIcon } from './Giftcards.svelte';
export { default as VpGridIcon } from './Grid.svelte';
export { default as VpGroupIcon } from './Group.svelte';
export { default as VpHailIcon } from './Hail.svelte';
export { default as VpHearingImpairmentIcon } from './HearingImpairment.svelte';
export { default as VpHeartFilledIcon } from './HeartFilled.svelte';
export { default as VpHeartPulseIcon } from './HeartPulse.svelte';
export { default as VpHeartIcon } from './Heart.svelte';
export { default as VpHistoryIcon } from './History.svelte';
export { default as VpHomeIcon } from './Home.svelte';
export { default as VpHourglassIcon } from './Hourglass.svelte';
export { default as VpImageIcon } from './Image.svelte';
export { default as VpInformationIcon } from './Information.svelte';
export { default as VpInsurranceIcon } from './Insurrance.svelte';
export { default as VpItalicIcon } from './Italic.svelte';
export { default as VpKeyboardIcon } from './Keyboard.svelte';
export { default as VpLeafIcon } from './Leaf.svelte';
export { default as VpLightbulbIcon } from './Lightbulb.svelte';
export { default as VpLightningIcon } from './Lightning.svelte';
export { default as VpLineChartIcon } from './LineChart.svelte';
export { default as VpLinkIcon } from './Link.svelte';
export { default as VpListCheckIcon } from './ListCheck.svelte';
export { default as VpListSettingsIcon } from './ListSettings.svelte';
export { default as VpLockIcon } from './Lock.svelte';
export { default as VpLogoutIcon } from './Logout.svelte';
export { default as VpLoyaltyCardIcon } from './LoyaltyCard.svelte';
export { default as VpMacIcon } from './Mac.svelte';
export { default as VpMacbookIcon } from './Macbook.svelte';
export { default as VpMailSendIcon } from './MailSend.svelte';
export { default as VpMailIcon } from './Mail.svelte';
export { default as VpMaintainRepairIcon } from './MaintainRepair.svelte';
export { default as VpMapPinIcon } from './MapPin.svelte';
export { default as VpMastercardIcon } from './Mastercard.svelte';
export { default as VpMaximizeIcon } from './Maximize.svelte';
export { default as VpMenuIcon } from './Menu.svelte';
export { default as VpMessageIcon } from './Message.svelte';
export { default as VpMicOffIcon } from './MicOff.svelte';
export { default as VpMicIcon } from './Mic.svelte';
export { default as VpMistIcon } from './Mist.svelte';
export { default as VpMoneyCnyBoxIcon } from './MoneyCnyBox.svelte';
export { default as VpMoneyDollarBoxIcon } from './MoneyDollarBox.svelte';
export { default as VpMoneyEuroBoxIcon } from './MoneyEuroBox.svelte';
export { default as VpMoneyPoundBoxIcon } from './MoneyPoundBox.svelte';
export { default as VpMoonCloudyIcon } from './MoonCloudy.svelte';
export { default as VpMoonIcon } from './Moon.svelte';
export { default as VpMore2Icon } from './More2.svelte';
export { default as VpMoreIcon } from './More.svelte';
export { default as VpMusic1Icon } from './Music1.svelte';
export { default as VpMusic2Icon } from './Music2.svelte';
export { default as VpNavigationIcon } from './Navigation.svelte';
export { default as VpNotificationIcon } from './Notification.svelte';
export { default as VpOrderTrackingIcon } from './OrderTracking.svelte';
export { default as VpParcelLockersIcon } from './ParcelLockers.svelte';
export { default as VpPauseCircleIcon } from './PauseCircle.svelte';
export { default as VpPauseFilledIcon } from './PauseFilled.svelte';
export { default as VpPauseIcon } from './Pause.svelte';
export { default as VpPhoneIcon } from './Phone.svelte';
export { default as VpPickUpPackstationIcon } from './PickUpPackstation.svelte';
export { default as VpPickUpStoreIcon } from './PickUpStore.svelte';
export { default as VpPictureInPictureIcon } from './PictureInPicture.svelte';
export { default as VpPieChartIcon } from './PieChart.svelte';
export { default as VpPlayCircleIcon } from './PlayCircle.svelte';
export { default as VpPlayFilledIcon } from './PlayFilled.svelte';
export { default as VpPlayIcon } from './Play.svelte';
export { default as VpPowerIcon } from './Power.svelte';
export { default as VpPriceTagIcon } from './PriceTag.svelte';
export { default as VpPrinterIcon } from './Printer.svelte';
export { default as VpQrCodeIcon } from './QrCode.svelte';
export { default as VpQrScanIcon } from './QrScan.svelte';
export { default as VpQuestionIcon } from './Question.svelte';
export { default as VpRainyIcon } from './Rainy.svelte';
export { default as VpRecycleIcon } from './Recycle.svelte';
export { default as VpRefreshIcon } from './Refresh.svelte';
export { default as VpRefundIcon } from './Refund.svelte';
export { default as VpRentIcon } from './Rent.svelte';
export { default as VpRepairIcon } from './Repair.svelte';
export { default as VpRepeatIcon } from './Repeat.svelte';
export { default as VpReturnIcon } from './Return.svelte';
export { default as VpRidingIcon } from './Riding.svelte';
export { default as VpRocketIcon } from './Rocket.svelte';
export { default as VpRssIcon } from './Rss.svelte';
export { default as VpRulerIcon } from './Ruler.svelte';
export { default as VpRunIcon } from './Run.svelte';
export { default as VpSearchIcon } from './Search.svelte';
export { default as VpSecondUseIcon } from './SecondUse.svelte';
export { default as VpSecurePaymentIcon } from './SecurePayment.svelte';
export { default as VpSeed1Icon } from './Seed1.svelte';
export { default as VpSeed2Icon } from './Seed2.svelte';
export { default as VpSeed3Icon } from './Seed3.svelte';
export { default as VpSendPlaneTopIcon } from './SendPlaneTop.svelte';
export { default as VpSendPlaneIcon } from './SendPlane.svelte';
export { default as VpSettingsIcon } from './Settings.svelte';
export { default as VpShareAndroidIcon } from './ShareAndroid.svelte';
export { default as VpShareAppleIcon } from './ShareApple.svelte';
export { default as VpShieldCheckIcon } from './ShieldCheck.svelte';
export { default as VpShoppingAddToBagIcon } from './ShoppingAddToBag.svelte';
export { default as VpShoppingBagIcon } from './ShoppingBag.svelte';
export { default as VpShoppingCartIcon } from './ShoppingCart.svelte';
export { default as VpShowerIcon } from './Shower.svelte';
export { default as VpSmartphoneIcon } from './Smartphone.svelte';
export { default as VpSnowyIcon } from './Snowy.svelte';
export { default as VpSparklesIcon } from './Sparkles.svelte';
export { default as VpStarFilledIcon } from './StarFilled.svelte';
export { default as VpStarHalfFilledIcon } from './StarHalfFilled.svelte';
export { default as VpStarIcon } from './Star.svelte';
export { default as VpStopCircleIcon } from './StopCircle.svelte';
export { default as VpStopFilledIcon } from './StopFilled.svelte';
export { default as VpStopIcon } from './Stop.svelte';
export { default as VpStoreIcon } from './Store.svelte';
export { default as VpSubtractIcon } from './Subtract.svelte';
export { default as VpSuitcaseStickersIcon } from './SuitcaseStickers.svelte';
export { default as VpSuitcaseWorkIcon } from './SuitcaseWork.svelte';
export { default as VpSunCloudyIcon } from './SunCloudy.svelte';
export { default as VpSunIcon } from './Sun.svelte';
export { default as VpTShirtNumberIcon } from './TShirtNumber.svelte';
export { default as VpTShirtIcon } from './TShirt.svelte';
export { default as VpTabletIcon } from './Tablet.svelte';
export { default as VpTacticsIcon } from './Tactics.svelte';
export { default as VpTaskIcon } from './Task.svelte';
export { default as VpTempColdIcon } from './TempCold.svelte';
export { default as VpTempHotIcon } from './TempHot.svelte';
export { default as VpTextCurvedIcon } from './TextCurved.svelte';
export { default as VpTextIcon } from './Text.svelte';
export { default as VpThumbDownIcon } from './ThumbDown.svelte';
export { default as VpThumbUpIcon } from './ThumbUp.svelte';
export { default as VpThunderstormsIcon } from './Thunderstorms.svelte';
export { default as VpTimeIcon } from './Time.svelte';
export { default as VpTimerIcon } from './Timer.svelte';
export { default as VpToolsIcon } from './Tools.svelte';
export { default as VpTrainIcon } from './Train.svelte';
export { default as VpTrophyIcon } from './Trophy.svelte';
export { default as VpTruckIcon } from './Truck.svelte';
export { default as VpUnlinkIcon } from './Unlink.svelte';
export { default as VpUploadIcon } from './Upload.svelte';
export { default as VpUserIcon } from './User.svelte';
export { default as VpVectorIcon } from './Vector.svelte';
export { default as VpVideoIcon } from './Video.svelte';
export { default as VpVolumeAlertIcon } from './VolumeAlert.svelte';
export { default as VpVolumeDownIcon } from './VolumeDown.svelte';
export { default as VpVolumeMuteIcon } from './VolumeMute.svelte';
export { default as VpVolumeUpIcon } from './VolumeUp.svelte';
export { default as VpWalkIcon } from './Walk.svelte';
export { default as VpWalletIcon } from './Wallet.svelte';
export { default as VpWarningErrorIcon } from './WarningError.svelte';
export { default as VpWifiOffIcon } from './WifiOff.svelte';
export { default as VpWifiOnIcon } from './WifiOn.svelte';
export { default as VpWindyIcon } from './Windy.svelte';
export { default as VpZoomInIcon } from './ZoomIn.svelte';
export { default as VpZoomOutIcon } from './ZoomOut.svelte';
export default getIconsMap;
